<script setup lang="ts">
import { useI18n } from 'petite-vue-i18n';
import { TEXT } from '../../configs/text';
import { useClassStore, useSignalRStore } from '../../stores';
import Heading from '../General/Heading.vue';
import Button from '../General/Button.vue';
import { ref, watch } from 'vue';
import { storeToRefs } from 'pinia';

const signalr = useSignalRStore()
const classStore = useClassStore()
const { selectedClassDetails: classDetails } = storeToRefs(classStore)

const selectedGroupId = ref<number>(0)

function handleSelectGroup(groupId: number) {
    if (classDetails.value?.student_group_id) return;
    selectedGroupId.value = groupId
}

function handleConfirmGroup() {
    if (!selectedGroupId.value) return;
    if (classDetails.value?.student_group_id) return;

    signalr.studentChooseGroup(selectedGroupId.value)
}

watch(() => classDetails.value?.student_group_id, () => {
    selectedGroupId.value = 0
})

const { t } = useI18n()
</script>

<template>
    <div class="bg-white rounded-lg p-4 md:p-8 mb-5">
        <Heading color="main" size="large">{{ t(TEXT.student_group) }}</Heading>
        <Heading alignment="center" size="large">{{ t(TEXT.let_s_choose_a_group) }}</Heading>
        <div class="flex flex-wrap justify-center gap-7 my-8">
            <Button v-for="group in classDetails?.groups"
                :color="classDetails?.student_group_id === group.id || selectedGroupId === group.id ? 'secondary' : 'info'"
                :shadow="false" size="large" class="!border-0 !p-8" @click="handleSelectGroup(group.id)">
                {{ group.name }}
            </Button>
        </div>
        <div v-if="classDetails?.student_group_id" class="text-center">
            {{
                t(TEXT.you_have_joined_group, {
                    group: classStore.getClassGroupNameById(classDetails.student_group_id)
                })
            }}
        </div>
        <div v-else>
            <Button size="large" :color="selectedGroupId ? 'success' : 'gray'" class="mx-auto" @click="handleConfirmGroup">
                {{ t(TEXT.confirm) }}
            </Button>
        </div>
    </div>
</template>